import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

const LOCALES = [
  { code: 'es', flag: '🇪🇸', labelKey: 'language.es' },
  { code: 'en', flag: '🇺🇸', labelKey: 'language.en' },
  { code: 'pt', flag: '🇧🇷', labelKey: 'language.pt' }
];

function normalizeLang(code) {
  return String(code || 'es').split('-')[0];
}

export default function FlagLanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [anchor, setAnchor] = useState(null);
  const current = LOCALES.find((l) => l.code === normalizeLang(i18n.language)) ?? LOCALES[0];

  const select = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('crm-lang', code);
    setAnchor(null);
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setAnchor(e.currentTarget)}
        aria-label={t('language.label')}
        sx={{ fontSize: 20, lineHeight: 1, px: 0.75 }}
      >
        {current.flag}
      </IconButton>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {LOCALES.map((locale) => (
          <MenuItem key={locale.code} selected={locale.code === current.code} onClick={() => select(locale.code)}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Typography component="span" sx={{ fontSize: 20, lineHeight: 1 }}>
                {locale.flag}
              </Typography>
              <Typography variant="body2">{t(locale.labelKey)}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
